import React, { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { useNavigate } from "react-router-dom";
import { useGetPatientQuery } from "@store/patientApi";
import Loader from "@components/Loader/Loader";
import OnboardingPicturesUpload from "@components/Onboarding/OnboardingPicturesUpload/OnboardingPicturesUpload";

const Pictures: FC = () => {
  const patientId = useSelector(
    (state: RootState) => state.home.selectedPatientId,
  );
  const accountId = useSelector((state: RootState) => state.account.accountId);
  const navigate = useNavigate();
  const { data: patient, isLoading } = useGetPatientQuery(patientId as string, {
    skip: !patientId,
  });

  useEffect(() => {
    if (!accountId) {
      navigate("/onboarding");
    } else if (!patient && !isLoading) {
      navigate("/onboarding/profile");
    }
  }, [patient, navigate, accountId, isLoading]);

  return (
    <>
      {isLoading || !patient ? (
        <Loader />
      ) : (
        <OnboardingPicturesUpload patient={patient} />
      )}
    </>
  );
};

export default Pictures;
